export default __webpack_public_path__ + "static/media/select-close-icon.1369dbd4.svg";